import script from "./CommerceSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./CommerceSettings.vue?vue&type=script&setup=true&lang=js"

import "./CommerceSettings.vue?vue&type=style&index=0&id=1454e026&scoped=true&lang=css"
import "./CommerceSettings.vue?vue&type=style&index=1&id=1454e026&lang=css"
import "./CommerceSettings.vue?vue&type=style&index=2&id=1454e026&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4197/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1454e026"]])

export default __exports__